import axios from "axios";
import { ENDPOINTS, getBaseURL } from "data/endpoints";
import { getHeaders } from "data/headers";

import { SurveyProfilerRequest } from "./interface";

export const getSurveyProfilerApi = (payload: SurveyProfilerRequest) => {
  const url = `/users/${payload.userId}${ENDPOINTS.SURVEY_PROFILER}`;
  return axios.get(getBaseURL() + url, {
    headers: getHeaders(),
  });
};
